module.exports = __webpack_public_path__ + "img/register-v2-dark.45da16f0.svg";